import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

function Header() {
    const location = useLocation();
    const home = location.pathname === "/";
    return (
        <header className="position-absolute top-0 w-100 d-flex">
        {
            !home &&
            <Link to={"/"} title="Exit to Home">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-house-fill" viewBox="0 0 16 16">
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z"/>
                <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z"/>
                </svg>
            </Link>
        }
        </header>
    )
}

export default Header;